import type { InitialCallStateCache } from "./initialCallStateCache"
import { convertUcsVolumeToAmnVolume } from "./volumeConversion"
import {
  getIsAudioMuted,
  getIsVideoDisabled,
  getAudioVolume,
} from "../../../ucs"

export type Props = {
  isConnected: boolean
  initialCallStateCache: InitialCallStateCache
}

export const handleRefreshCallEvent = async (props: Props) => {
  try {
    const initialCallState = await resolveInitialCallState(props)
    const { disableAudio, disableVideo, initialVolume } = initialCallState
    const amnVolume = convertUcsVolumeToAmnVolume(initialVolume)
    const originalUrl = window.location.href

    const url = new URL(originalUrl)
    url.searchParams.set("amn.disableAudio", disableAudio ? "1" : "0")
    url.searchParams.set("amn.disableVideo", disableVideo ? "1" : "0")
    url.searchParams.set("amn.initialVolume", amnVolume.toString())
    const newUrl = url.toString()

    // eslint-disable-next-line no-console
    console.log("Refreshing page", {
      isConnected: props.isConnected,
      initialCallState,
      originalUrl,
      newUrl,
    })
    window.location.href = newUrl
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error refreshing call", error)
  }
}

type InitialCallState = {
  disableAudio: boolean
  disableVideo: boolean
  initialVolume: number
}

/**
 * Before reloading the page, we must capture the current call state to ensure
 * that AMN and UCS UIs remain in sync.
 */
export const resolveInitialCallState = async ({
  isConnected,
  initialCallStateCache,
}: Props): Promise<InitialCallState> => {
  if (isConnected) {
    const [disableAudio, disableVideo, initialVolume] = await Promise.all([
      getIsAudioMuted(),
      getIsVideoDisabled(),
      getAudioVolume(),
    ])
    return { disableAudio, disableVideo, initialVolume }
  } else {
    return {
      disableAudio: !initialCallStateCache.isAudioEnabled(),
      disableVideo: !initialCallStateCache.isVideoEnabled(),
      initialVolume: initialCallStateCache.getInitialVolume(),
    }
  }
}
